import { Component, OnInit, Inject } from '@angular/core';
import { BillingExportTypeFilter } from '../../../model/billing/billing-export-type-filter';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BillingExportTypeService } from '../../../services/billing/billing-export-type.service';

@Component({
  selector: 'app-billing-export-type-dialog',
  templateUrl: './billing-export-type-dialog.component.html',
  styles: []
})
export class BillingExportTypeDialogComponent implements OnInit {

  billingExportTypeFilters: BillingExportTypeFilter[] = [];
  form: FormGroup;
  loading: boolean;

  constructor(public dialogRef: MatDialogRef<BillingExportTypeDialogComponent>,
    private formBuilder: FormBuilder,
    private billingExportService: BillingExportTypeService,
    @Inject(MAT_DIALOG_DATA) public data: number) {

      this.form = this.formBuilder.group({
        billingExportType: ['', Validators.required]
      });
    }

  get f() { return this.form.controls; }

  async ngOnInit() {
    this.loading = true;
    this.billingExportTypeFilters = await this.billingExportService
      .getBillingExportTypeFilter(this.data);
    this.loading = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  accept() {
    if ( this.form.valid ) {
      this.dialogRef.close(this.form.getRawValue().billingExportType);
    }
  }
}
